var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user)?_c('a',{staticClass:"float-right sair",attrs:{"href":"/"},on:{"click":_vm.logout}},[_c('i',{staticClass:"fas fa-power-off"}),_vm._v(_vm._s(_vm.logoutTranslation))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }